import { EColorScheme } from '@/redux/css';
import { zIndexes } from '@styles/constants.styled';
import Lottie from 'lottie-react';
import styled, { css } from 'styled-components';

export const StyledContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${zIndexes.loaderOverlay};
`;
export const StyledOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.7;
`;
export const LoaderContainer = styled.div`
position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 280px;
background: var(--default-bg-color);
outline: 3px solid var(--default-bg-color);
outline-offset: 10px;
border: 3px solid var(--default-bg-color);
display: flex;
flex-direction: column;
align-items: center;
max-width: 379px;
padding: 28px 20px;
border-radius: 5px;
`;
export const StyledLoaderText = styled.p`
  position: inherit;
  width: 300%;
  right: 0%;
  left: -100%;
  padding-top: 120%;
  height: 100%;
  color: white;
  opacity: 0.7;
  text-align: center;
`;
export const Loader = styled(Lottie)``;

export const StyledLoader = styled(Lottie)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
`;
export const StyledLoaderTheme = css`
  &[data-theme='${EColorScheme.NIGHT}'] {
    --default-bg-color: #383a69;
    ${StyledLoaderText} {
      --theme-StyledLoaderText-color: var(--theme-main-color-inverse);
    }
  }
  &[data-theme='${EColorScheme.DAY}'] {
    --default-bg-color: linear-gradient(
      90.05deg,
      #a01f83 0.01%,
      #ee745f 99.93%
    );

    ${StyledLoaderText} {
      --theme-StyledLoaderText-color: var(--theme-day-blue-2);
    }

  }
`;
